/**
 * @summary Contains a utility that parses a string into HTML objects.
 */

/**
 * @summary Parses a string into HTML objects.
 *
 * @param {String} markup The HTML fragment string to parse.
 * @returns {HTMLElement[]} The HTML element objects.
 */
export default markup => {
	const slave = document.createElement( 'div' );
	slave.innerHTML = markup;
	return Array.from( slave.children );
};



// WEBPACK FOOTER //
// ./src/js/parse-html.js